export default __webpack_public_path__ + "static/media/notices-icon-active.cc017746.svg";